import getOwnersByParzInfo from './getOwnersByParzInfo'
import styleFeature from './styleFeature'

const styleFeatures = (feature, newData) => {
  // read parzNumber from feature
  const GSTNR = feature.getProperty('GSTNR')

  // get corresponding items
  const owners = getOwnersByParzInfo(newData, GSTNR, 'grundstueck-nr')

  // calculate style
  const styles = styleFeature(owners)

  return {
    fillColor: styles.fillColor,
    strokeOpacity: styles.strokeOpacity,
    fillOpacity: styles.fillOpacity,
    clickable: styles.clickable,
    strokeWeight: 1,
    zindex: styles.zindex
  }
}

export default styleFeatures



// WEBPACK FOOTER //
// ./src/logic/styleFeatures.js